'use strict';

exports.__esModule = true;
exports.notifications = exports.get = exports.update = exports.create = undefined;

var _http = require('../network/http');

var _apiClient = require('../network/api-client');

var _apiClient2 = _interopRequireDefault(_apiClient);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var API = {
  REGISTER_REGISTER: '/partner/register',
  PARTNER_USER: '/partner/user',
  PARTNER_USER_NOTIFICATIONS: '/partner/user/notifications'

  /**
   * Create a new partner user
   * @param {object} user - user object
   * @returns {User} containing the entity object user
   */
};var create = exports.create = function create(partnerUser) {
  return (0, _http.post)(API.REGISTER_REGISTER, partnerUser);
};

/**
 * Update the account details for a logged-in user
 * @param {object} user - user object
 * @returns {User} containing the entity object user
 */
var update = exports.update = function update(partnerUser) {
  return (0, _http.put)(API.PARTNER_USER, partnerUser);
};

/**
 * Get a user
 * @returns {User} containing the entity object user
 */
var get = exports.get = function get(partnerUser) {
  return (0, _http.get)(API.PARTNER_USER, partnerUser);
};

/**
 * Get the current user's notification
 * @returns {Notifications} containing the entity object user
 */
var notifications = exports.notifications = function notifications() {
  return _apiClient2.default.get({ route: API.PARTNER_USER_NOTIFICATIONS, includeAuth: true });
};

exports.default = {
  create: create,
  update: update,
  get: get,
  notifications: notifications
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@quiqupltd/quiqupjs/lib/partner/user.js
// module id = 1082
// module chunks = 0